import React, { Component } from "react";
import moment from "moment";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import { FloorDetailScreen } from "../FloorScreens";
import Colors from "../../common/Colors";
import SwitchTable from "../../components/SwitchTable";
import Header from "../../components/Header";
import Toast from "../../components/Toast";
import { Tooltip, Paper, Typography, Box, Chip, Avatar, Button, Badge } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { styled } from '@mui/material/styles';

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#1E293B",
  accentColor: "#BB0A21",
  textColor: "#F8FAFC",
  secondaryText: "#94A3B8",
  highlightColor: "#7C3AED",
};

const StatusBadge = styled(Chip)(({ status }) => ({
  backgroundColor: getStatusColor(status),
  color: status === "waiting" ? "#000" : "#fff",
  fontWeight: "bold",
  textTransform: 'uppercase',
  fontSize: '0.65rem',
  padding: '0 8px',
  height: '24px',
  '& .MuiChip-icon': {
    color: status === "waiting" ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.8)',
    fontSize: '14px',
    marginLeft: '4px'
  }
}));

const TokenCard = styled(Paper)({
  backgroundColor: ColorScheme.componentColor,
  borderRadius: "16px",
  overflow: "hidden",

  position: "relative",
  cursor: "pointer",
  transition: "all 0.3s ease",
  // border: `1px solid ${ColorScheme.componentColor}`,
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: `0 10px 20px rgba(0,0,0,0.3)`,
    // borderColor: ColorScheme.buttonColor
  },
});

const TokenCircle = styled(Box)({
  width: "100px",
  height: "100px",
  borderRadius: "50%",
  backgroundColor: ColorScheme.buttonColor,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0 4px 20px rgba(255, 200, 87, 0.3)",
  margin: '0 auto',
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    border: `2px dashed ${ColorScheme.buttonColor}`,
    opacity: 0.2
  }
});

const DetailRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "12px",
  padding: '8px 0',
  borderBottom: `1px solid rgba(148, 163, 184, 0.1)`,
  '&:last-child': {
    borderBottom: 'none'
  }
});

const AssignButton = styled(Button)({
  backgroundColor: "#00A651",
  color: "white",
  fontWeight: "600 !important",
  borderRadius: "8px !important",
  padding: "8px 24px !important",
  textTransform: "none !important",
  boxShadow: "none !important",
  transition: "all 0.2s ease !important",
  "&:hover": {
    // transform: "translateY(-2px) !important",

    backgroundColor: "#00A651 !important",
  }
});

const getStatusColor = (status) => {
  switch (status) {
    case "waiting":
      return "#FFC857"; // Yellow
    case "assigned":
      return "#10B981"; // Green
    case "cancelled":
      return "#EF4444"; // Red
    default:
      return "#64748B"; // Gray
  }
};

const getStatusIcon = (status) => {
  switch (status) {
    case "waiting":
      return <AccessTimeIcon fontSize="small" />;
    case "assigned":
      return <RestaurantIcon fontSize="small" />;
    case "cancelled":
      return <PriorityHighIcon fontSize="small" />;
    default:
      return null;
  }
};

class ListMenuScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      switchTableOpen: false,
      selectedTokenOrderId: null,
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    };
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getData();
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };

  getData = async () => {
    const url = URL_PATH.ListDigitalTokenForHotel(
      this.props.selectedHotelId.id
    );

    try {
      const { status, message, data } = await API(this, "get", url);

      if (status === "success") {
        this.setState({ data });
      } else {
        this.showToast(message || "Failed to fetch tokens", "error");
      }
    } catch (error) {
      console.error("Error fetching tokens:", error);
      this.showToast("An error occurred while fetching tokens", "error");
    }
  };

  onDelete = async (item) => {
    try {
      const { status, message } = await API(
        this,
        "post",
        URL_PATH.deleteMenu(item.id)
      );

      if (status === "success") {
        this.showToast(message, "success");
        this.getData();
      } else {
        this.showToast(message, "error");
      }
    } catch (error) {
      console.error("Error deleting token:", error);
      this.showToast("An error occurred while deleting the token", "error");
    }
  };

  handleSuccess = () => {
    this.setState({ switchTableOpen: false });
    this.getData();
  };

  formatTime = (timestamp) => {
    return moment(timestamp).format("hh:mm A");
  };

  formatDate = (timestamp) => {
    return moment(timestamp).format("MMM DD, YYYY");
  };

  getWaitingTime = (timestamp) => {
    const created = moment(timestamp);
    const now = moment();
    const duration = moment.duration(now.diff(created));

    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.asMinutes()) % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  };

  render() {
    const { data, switchTableOpen, selectedTokenOrderId } = this.state;

    return (
      <div className="container-fluid" style={{
        backgroundColor: ColorScheme.bgColor,
        minHeight: "100vh",
        padding: "24px",

      }}>
        <Header title="Digital Tokens" color={ColorScheme.textColor} />

        <div style={{
          marginTop: "24px",
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          {data.length === 0 ? (
            <Paper
              elevation={0}
              sx={{
                padding: "40px",
                textAlign: "center",
                backgroundColor: "#041A29",
                color: ColorScheme.textColor,
                borderRadius: '16px'
              }}
            >
              <RestaurantIcon sx={{ fontSize: '48px', color: ColorScheme.secondaryText, mb: 2 }} />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>No active tokens</Typography>
              <Typography variant="body2" sx={{
                marginTop: "8px",
                color: ColorScheme.secondaryText,
                maxWidth: '400px',
                margin: '12px auto 0'
              }}>
                When customers join the waiting list, their digital tokens will appear here for you to manage.
              </Typography>
            </Paper>
          ) : (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "24px",

              alignItems: "stretch"
            }}>
              {data.map((item, index) => (
                <TokenCard
                  key={index}
                  elevation={3}
                  onClick={() => {
                    this.setState({
                      switchTableOpen: true,
                      selectedTokenOrderId: item.order_id,
                    });
                  }}
                >



                  {/* Token Circle */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "30px 0 10px",
                      backgroundColor: "#041A29",
                      position: 'relative',
                      overflow: 'hidden',
                      '&:before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '3px',
                        background: "#FFC857",
                        opacity: 0.6
                      }
                    }}
                  >
                    <Badge
                      badgeContent={
                        <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
<PersonIcon sx={{ fontSize: '16px' }} />
                          <span>{item.number_of_people}</span>
                        </Box>
                      }
                      color="primary"
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                    sx={{
  '& .MuiBadge-badge': {
    backgroundColor: "#BB0A21",
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '0.70rem',
    width: '35px',              // Set width equal to height
    height: '35px',
    borderRadius: '50%',    
    marginBottom:"10px",    // Circular shape
    display: 'flex',            // Center text horizontally
    alignItems: 'center',       // Center text vertically
    justifyContent: 'center',
    padding: 0,                 // Remove extra padding
  }
}}

                    >
                      <TokenCircle>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#000",
                            fontWeight: "bold",
                            position: 'relative',
                            zIndex: 1
                          }}
                        >
                          {item.id}
                        </Typography>
                      </TokenCircle>
                    </Badge>
                  </Box>

                  {/* Card Content */}
                  <Box sx={{ padding: "20px 24px 24px", backgroundColor: "#041A29" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        color: ColorScheme.textColor,
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: '1.1rem',
                        mb: 1
                      }}
                    >
                      {item.user?.name || "Guest"}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        color: ColorScheme.secondaryText,
                        textAlign: "center",
                        fontSize: '0.85rem',
                        mb: 2
                      }}
                    >
                      {this.formatDate(item.created_at)}
                    </Typography>

                    <Box sx={{ mt: 3 }}>
                      <DetailRow>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <PersonIcon sx={{
                            color: ColorScheme.secondaryText,
                            mr: 1,
                            fontSize: '20px'
                          }} />
                          <Typography variant="body2" sx={{ color: ColorScheme.secondaryText }}>
                            Order #
                          </Typography>
                        </Box>
                        <Typography variant="body2" sx={{
                          color: ColorScheme.textColor,
                          fontWeight: 500
                        }}>
                          {item.order_id}
                        </Typography>
                      </DetailRow>

                      <DetailRow>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <AccessTimeIcon sx={{
                            color: ColorScheme.secondaryText,
                            mr: 1,
                            fontSize: '20px'
                          }} />
                          <Typography variant="body2" sx={{ color: ColorScheme.secondaryText }}>
                            Waiting time
                          </Typography>
                        </Box>
                        <Typography variant="body2" sx={{
                          color: ColorScheme.buttonColor,
                          fontWeight: "bold",
                          fontSize: '1rem'
                        }}>
                          {this.getWaitingTime(item.created_at)}
                        </Typography>
                      </DetailRow>

                      <Box sx={{
                        display: "flex",
                        justifyContent: "center",

                        pt: 2
                      }}>
                        <AssignButton
                          variant="contained"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              switchTableOpen: true,
                              selectedTokenOrderId: item.order_id,
                            });
                          }}
                        >
                          Assign Table
                        </AssignButton>
                      </Box>
                    </Box>
                  </Box>
                </TokenCard>
              ))}
            </div>
          )}
        </div>

        {switchTableOpen && (
          <SwitchTable
            onCancel={() => {
              this.setState({ switchTableOpen: false });
            }}
            handleSuccess={this.handleSuccess}
            isOpen={switchTableOpen}
            apiCall={this.apiCall}
            orderId={selectedTokenOrderId}
          />
        )}

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          onClose={this.handleCloseToast}
        />
      </div>
    );
  }
}

export default redux(ListMenuScreen);